export default function () {

    const typesLabels = {
        DEPOSIT: 'DEPÓSITO',
        WITHDRAW: 'SAQUE',
        REMOVAL: 'RETIRADA',
        MANUAL: 'MANUAL',
    }

    const statusLabels = {
        PENDING: 'PENDENTE',
        PAID: 'PAGO',
        CANCELED: 'CANCELADO',
        REFUSED: 'RECUSADO',
        EXPIRED: 'EXPIRADO',
        REFUNDED: 'REEMBOLSADO',
        PENDING_REFUNDED: 'REEMBOLSO PENDENTE',
    }

    const typesOptions = [
        {name: 'DEPÓSITO', value: 'DEPOSIT'},
        {name: 'SAQUE', value: 'WITHDRAW'},
        {name: 'RETIRADA', value: 'REMOVAL'},
        {name: 'MANUAL', value: 'MANUAL'},
    ]

    const statusOptions = [
        {name: 'PENDENTE', value: 'PENDING'},
        {name: 'PAGO', value: 'PAID'},
        {name: 'CANCELADO', value: 'CANCELED'},
        {name: 'RECUSADO', value: 'REFUSED'},
        {name: 'EXPIRADO', value: 'EXPIRED'},
        {name: 'REEMBOLSADO', value: 'REFUNDED'},
        {name: 'REEMBOLSO PENDENTE', value: 'PENDING_REFUNDED'},
    ]

    // status que o painel pode aplicar à mão (espelha MANUAL_STATUS_OPTIONS no backend)
    const manualStatusOptions = [
        {name: 'PAGO', value: 'PAID', icon: 'pi pi-check-circle'},
        {name: 'CANCELADO', value: 'CANCELED', icon: 'pi pi-ban'},
    ]

    // histórico de webhooks: espelha ClientWebhookDelivery, ClientWebhookDeliveryAttempt e
    // VendorWebhookEvent no backend
    const webhookDeliveryStatusLabels = {
        PENDING: 'PENDENTE',
        SENDING: 'ENVIANDO',
        DELIVERED: 'ENTREGUE',
        FAILED: 'FALHOU',
        // o status que ela comunicava mudou antes da entrega: quem vale é a notificação seguinte
        SUPERSEDED: 'SUBSTITUÍDA',
    }

    const webhookDeliveryOriginLabels = {
        VENDOR_WEBHOOK: 'RETORNO DO FORNECEDOR',
        MANUAL_STATUS: 'ALTERAÇÃO MANUAL',
        // emitida no painel para um desfecho que nunca chegou a ser comunicado ao cliente
        MANUAL_NOTIFICATION: 'EMISSÃO MANUAL',
    }

    const webhookAttemptKindLabels = {
        AUTOMATIC: 'AUTOMÁTICA',
        MANUAL: 'MANUAL',
    }

    const webhookAttemptOutcomeLabels = {
        SUCCESS: 'SUCESSO',
        HTTP_ERROR: 'ERRO HTTP',
        TIMEOUT: 'TEMPO ESGOTADO',
        NETWORK_ERROR: 'FALHA DE CONEXÃO',
    }

    const vendorWebhookResultLabels = {
        APPLIED: 'APLICADO',
        IGNORED: 'REGISTRADO',
        ERROR: 'ERRO',
        UNKNOWN: 'NÃO PROCESSADO',
    }

    const pixKeyTypesLabels = {
        CPF: 'CPF',
        CNPJ: 'CNPJ',
        PHONE: 'CELULAR',
        EMAIL: 'EMAIL',
        RANDOM_KEY: 'CHAVE ALEATÓRIA',
    }

    return {
        typesLabels,
        statusLabels,
        typesOptions,
        statusOptions,
        manualStatusOptions,
        webhookDeliveryStatusLabels,
        webhookDeliveryOriginLabels,
        webhookAttemptKindLabels,
        webhookAttemptOutcomeLabels,
        vendorWebhookResultLabels,
        pixKeyTypesLabels
    }
    
}